// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__IaY4I.styles_ocean-50__PDj2m {
  color: #e6f2ff;
}

.styles_color__IaY4I.styles_ocean-100__4kNo2 {
  color: #e6f2ff;
}

.styles_color__IaY4I.styles_ocean-200__1BufJ {
  color: #b3daff;
}

.styles_color__IaY4I.styles_ocean-300__YVPwl {
  color: #7abfff;
}

.styles_color__IaY4I.styles_ocean-400__5iAOn {
  color: #2392fb;
}

.styles_color__IaY4I.styles_ocean-500__cO-1n {
  color: #0074e0;
}

.styles_color__IaY4I.styles_ocean-600__69uMr {
  color: #043571;
}

.styles_color__IaY4I.styles_space-50__5lYoZ {
  color: #f0f0f0;
}

.styles_color__IaY4I.styles_space-100__FENmI {
  color: #e3e3e3;
}

.styles_color__IaY4I.styles_space-200__QwtQg {
  color: #bfbfbf;
}

.styles_color__IaY4I.styles_space-300__Sij6X {
  color: gray;
}

.styles_color__IaY4I.styles_space-400__JqxKs {
  color: #616161;
}

.styles_color__IaY4I.styles_space-500__lHOZT {
  color: #283439;
}

.styles_color__IaY4I.styles_gray-50__e-R8i {
  color: #eff3f6;
}

.styles_color__IaY4I.styles_gray-100__9tULX {
  color: #e6ecef;
}

.styles_color__IaY4I.styles_gray-200__A0NGE {
  color: #cfd8de;
}

.styles_color__IaY4I.styles_gray-300__60uF- {
  color: #a8b9c2;
}

.styles_color__IaY4I.styles_gray-400__hsRLn {
  color: #7e98a5;
}

.styles_color__IaY4I.styles_gray-500__mqB2z {
  color: #738f9c;
}

.styles_color__IaY4I.styles_green-50__LhPRY {
  color: #e3fdf6;
}

.styles_color__IaY4I.styles_green-100__kUqPz {
  color: #c5f6ea;
}

.styles_color__IaY4I.styles_green-200__sBU\\+S {
  color: #69ddc2;
}

.styles_color__IaY4I.styles_green-300__la58s {
  color: #45bfa3;
}

.styles_color__IaY4I.styles_green-400__tTQQD {
  color: #1cab8a;
}

.styles_color__IaY4I.styles_green-500__qCq1j {
  color: #128268;
}

.styles_color__IaY4I.styles_red-50__VlNH6 {
  color: #fff0f3;
}

.styles_color__IaY4I.styles_red-100__KzPb1 {
  color: #f9d2db;
}

.styles_color__IaY4I.styles_red-200__1yqc4 {
  color: #f8b4c4;
}

.styles_color__IaY4I.styles_red-300__q0gsM {
  color: #e85e81;
}

.styles_color__IaY4I.styles_red-400__mvorP {
  color: #e23661;
}

.styles_color__IaY4I.styles_red-500__en3L9 {
  color: #b82348;
}

.styles_color__IaY4I.styles_yellow-50__Kzi4h {
  color: #fffae6;
}

.styles_color__IaY4I.styles_yellow-100__RUAaU {
  color: #fff0b3;
}

.styles_color__IaY4I.styles_yellow-200__-X4rL {
  color: #ffe380;
}

.styles_color__IaY4I.styles_yellow-300__0gBKf {
  color: #ffcf57;
}

.styles_color__IaY4I.styles_yellow-400__6TYWe {
  color: #ffc60a;
}

.styles_color__IaY4I.styles_yellow-500__GT5ie {
  color: #ffb700;
}

.styles_color__IaY4I.styles_orange-50__4sQaA {
  color: #fff2eb;
}

.styles_color__IaY4I.styles_orange-100__xJGBj {
  color: #ffe4d6;
}

.styles_color__IaY4I.styles_orange-200__CmNFy {
  color: #ffc69e;
}

.styles_color__IaY4I.styles_orange-300__3qSvE {
  color: #ffa047;
}

.styles_color__IaY4I.styles_orange-400__WXUo5 {
  color: #ff7b42;
}

.styles_color__IaY4I.styles_orange-500__SjqoD {
  color: #ee4920;
}

.styles_color__IaY4I.styles_turquoise-50__9ATAF {
  color: transparent;
}

.styles_color__IaY4I.styles_turquoise-100__FC1hI {
  color: #e6fcff;
}

.styles_color__IaY4I.styles_turquoise-200__nazzB {
  color: #b3f5ff;
}

.styles_color__IaY4I.styles_turquoise-300__iVbJ7 {
  color: #78e2f2;
}

.styles_color__IaY4I.styles_turquoise-400__7UX2Q {
  color: #00c7e6;
}

.styles_color__IaY4I.styles_turquoise-500__PSAxv {
  color: transparent;
}

.styles_color__IaY4I.styles_turquoise-600__jIYJy {
  color: transparent;
}

.styles_color__IaY4I.styles_violet-50__LtqWn {
  color: #eae6ff;
}

.styles_color__IaY4I.styles_violet-100__k7vwJ {
  color: #d9d1ff;
}

.styles_color__IaY4I.styles_violet-200__fn83b {
  color: #bfb3ff;
}

.styles_color__IaY4I.styles_violet-300__Qqalu {
  color: #9d90ea;
}

.styles_color__IaY4I.styles_violet-400__jcjta {
  color: #8678d9;
}

.styles_color__IaY4I.styles_violet-500__KuOyJ {
  color: #6f5ccc;
}

.styles_color__IaY4I.styles_snow-50__\\+NVjB {
  color: white;
}

.styles_color__IaY4I.styles_snow-100__qPbus {
  color: #f7f7f7;
}

.styles_color__IaY4I.styles_snow-200__B\\+1V5 {
  color: #f0efef;
}

.styles_color__IaY4I.styles_snow-300__bDc4l {
  color: #e6e6e6;
}

.styles_color__IaY4I.styles_snow-400__DFDJJ {
  color: #e1e0e0;
}

.styles_color__IaY4I.styles_snow-500__t3Vkl {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__uzLsK.styles_ocean__g6avJ {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__uzLsK.styles_ocean-light__j-z15 {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__uzLsK.styles_green__pwEkx {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__uzLsK.styles_green-light__mNEE7 {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__uzLsK.styles_red__ZART3 {
  background-color: #e23661;
  color: white;
}

.styles_background-color__uzLsK.styles_red-light__-LBhb {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__uzLsK.styles_orange__62qOb {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__uzLsK.styles_orange-light__fRYrf {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__uzLsK.styles_space__lp56S {
  background-color: #616161;
  color: white;
}

.styles_background-color__uzLsK.styles_space-light__glHHh {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__uzLsK.styles_gray-light__JTflf {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__uzLsK.styles_violet__Ri9BN {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__uzLsK.styles_violet-light__bx8ko {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__uzLsK.styles_yellow__zoC7e {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__uzLsK.styles_yellow-light__UXdkt {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_root__eH0kU {
  background-color: white;
  border-radius: 0;
  box-shadow: 0 3px 5px rgba(9, 30, 66, 0.2), 0 0 1px rgba(9, 30, 66, 0.31);
  color: #283439;
  padding: 8px 16px ;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 1700;
}
.styles_root__eH0kU .styles_inner__F44IP {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px ;
}
.styles_root__eH0kU .styles_avatarTitleWrapper__YhXS4 {
  flex: 1 1 auto;
  min-width: 160px ;
  overflow: hidden;
}
.styles_root__eH0kU .styles_actions__RuDuD {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  margin-left: auto;
}
.styles_root__eH0kU .styles_iconButton__5zK1S {
  margin-left: 16px ;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/components/chat/voip-panel/incoming-call-box/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA;EACI,uBAAA;EACA,gBAAA;EACA,yEAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;AA0UJ;AAxUI;EACI,mBAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;AA0UR;AAvUI;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;AAyUR;AAtUI;EACI,mBAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AAwUR;AArUI;EACI,kBAAA;AAuUR","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n.root {\n    background-color: theme.color(snow-50);\n    border-radius: 0;\n    box-shadow: theme.box-shadow(md);\n    color: theme.color(space-500);\n    padding: theme.spacing(1, 2);\n    position: fixed;\n    right: 0;\n    top: 0;\n    width: 100%;\n    z-index: theme.get-z-index(incoming-call-bar);\n\n    .inner {\n        align-items: center;\n        display: flex;\n        flex-wrap: wrap;\n        row-gap: theme.spacing(1);\n    }\n\n    .avatarTitleWrapper {\n        flex: 1 1 auto;\n        min-width: theme.spacing(20);\n        overflow: hidden;\n    }\n\n    .actions {\n        align-items: center;\n        display: flex;\n        flex-shrink: 0;\n        margin-left: auto;\n    }\n\n    .iconButton {\n        margin-left: theme.spacing(2);\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__IaY4I`,
	"ocean-50": `styles_ocean-50__PDj2m`,
	"ocean-100": `styles_ocean-100__4kNo2`,
	"ocean-200": `styles_ocean-200__1BufJ`,
	"ocean-300": `styles_ocean-300__YVPwl`,
	"ocean-400": `styles_ocean-400__5iAOn`,
	"ocean-500": `styles_ocean-500__cO-1n`,
	"ocean-600": `styles_ocean-600__69uMr`,
	"space-50": `styles_space-50__5lYoZ`,
	"space-100": `styles_space-100__FENmI`,
	"space-200": `styles_space-200__QwtQg`,
	"space-300": `styles_space-300__Sij6X`,
	"space-400": `styles_space-400__JqxKs`,
	"space-500": `styles_space-500__lHOZT`,
	"gray-50": `styles_gray-50__e-R8i`,
	"gray-100": `styles_gray-100__9tULX`,
	"gray-200": `styles_gray-200__A0NGE`,
	"gray-300": `styles_gray-300__60uF-`,
	"gray-400": `styles_gray-400__hsRLn`,
	"gray-500": `styles_gray-500__mqB2z`,
	"green-50": `styles_green-50__LhPRY`,
	"green-100": `styles_green-100__kUqPz`,
	"green-200": `styles_green-200__sBU+S`,
	"green-300": `styles_green-300__la58s`,
	"green-400": `styles_green-400__tTQQD`,
	"green-500": `styles_green-500__qCq1j`,
	"red-50": `styles_red-50__VlNH6`,
	"red-100": `styles_red-100__KzPb1`,
	"red-200": `styles_red-200__1yqc4`,
	"red-300": `styles_red-300__q0gsM`,
	"red-400": `styles_red-400__mvorP`,
	"red-500": `styles_red-500__en3L9`,
	"yellow-50": `styles_yellow-50__Kzi4h`,
	"yellow-100": `styles_yellow-100__RUAaU`,
	"yellow-200": `styles_yellow-200__-X4rL`,
	"yellow-300": `styles_yellow-300__0gBKf`,
	"yellow-400": `styles_yellow-400__6TYWe`,
	"yellow-500": `styles_yellow-500__GT5ie`,
	"orange-50": `styles_orange-50__4sQaA`,
	"orange-100": `styles_orange-100__xJGBj`,
	"orange-200": `styles_orange-200__CmNFy`,
	"orange-300": `styles_orange-300__3qSvE`,
	"orange-400": `styles_orange-400__WXUo5`,
	"orange-500": `styles_orange-500__SjqoD`,
	"turquoise-50": `styles_turquoise-50__9ATAF`,
	"turquoise-100": `styles_turquoise-100__FC1hI`,
	"turquoise-200": `styles_turquoise-200__nazzB`,
	"turquoise-300": `styles_turquoise-300__iVbJ7`,
	"turquoise-400": `styles_turquoise-400__7UX2Q`,
	"turquoise-500": `styles_turquoise-500__PSAxv`,
	"turquoise-600": `styles_turquoise-600__jIYJy`,
	"violet-50": `styles_violet-50__LtqWn`,
	"violet-100": `styles_violet-100__k7vwJ`,
	"violet-200": `styles_violet-200__fn83b`,
	"violet-300": `styles_violet-300__Qqalu`,
	"violet-400": `styles_violet-400__jcjta`,
	"violet-500": `styles_violet-500__KuOyJ`,
	"snow-50": `styles_snow-50__+NVjB`,
	"snow-100": `styles_snow-100__qPbus`,
	"snow-200": `styles_snow-200__B+1V5`,
	"snow-300": `styles_snow-300__bDc4l`,
	"snow-400": `styles_snow-400__DFDJJ`,
	"snow-500": `styles_snow-500__t3Vkl`,
	"background-color": `styles_background-color__uzLsK`,
	"ocean": `styles_ocean__g6avJ`,
	"ocean-light": `styles_ocean-light__j-z15`,
	"green": `styles_green__pwEkx`,
	"green-light": `styles_green-light__mNEE7`,
	"red": `styles_red__ZART3`,
	"red-light": `styles_red-light__-LBhb`,
	"orange": `styles_orange__62qOb`,
	"orange-light": `styles_orange-light__fRYrf`,
	"space": `styles_space__lp56S`,
	"space-light": `styles_space-light__glHHh`,
	"gray-light": `styles_gray-light__JTflf`,
	"violet": `styles_violet__Ri9BN`,
	"violet-light": `styles_violet-light__bx8ko`,
	"yellow": `styles_yellow__zoC7e`,
	"yellow-light": `styles_yellow-light__UXdkt`,
	"root": `styles_root__eH0kU`,
	"inner": `styles_inner__F44IP`,
	"avatarTitleWrapper": `styles_avatarTitleWrapper__YhXS4`,
	"actions": `styles_actions__RuDuD`,
	"iconButton": `styles_iconButton__5zK1S`
};
export default ___CSS_LOADER_EXPORT___;
